var AUTH0_CLIENT_ID='UCFQIBMNFoUk5e19SDujYKTYC463r7rI';
var AUTH0_DOMAIN='ml-for-kids.auth0.com';
var AUTH0_CUSTOM_DOMAIN='login.machinelearningforkids.co.uk';
var AUTH0_CDN_BASE='https://cdn.auth0.com';
var AUTH0_CALLBACK_URL=window.location.href;
var AUTH0_AUDIENCE='https://machinelearningforkids.co.uk/users';
var REQUESTED_SCOPES='openid email write:training';
// needed for numbers service
var AUTH0_WHITELISTED_DOMAINS=[
    'https://mlforkids-newnumbers.j8ahcaxwtd1.au-syd.codeengine.appdomain.cloud',
    'https://mlforkids-newnumbers.j8clybxvjr0.us-south.codeengine.appdomain.cloud',
    'https://mlforkids-newnumbers.j8ayd8ayn23.eu-de.codeengine.appdomain.cloud'
];
